import React from 'react';
import EmptyPage from '../EmptyPage';

const ClientManagePage: React.FC = () => {
  return (
    <EmptyPage
      title="고객사 관리"
      icon="Building"
      description="고객사 정보를 관리합니다."
    />
  );
};

export default ClientManagePage;
